<template>
  <!-- Impacto de las COs: sumatoria de COs confirmadas, pendientes y su total. -->
  <div class="impact">
    <div class="impact-title">
      <b-icon pack="fas" icon="arrow-trend-down" size="is-small"></b-icon>
      <span>{{ $t('prm_impact_title') }}</span>
      <span class="impact-sub">
        {{ impact.expectedCount === 0 ? $t('prm_impact_none') : impact.expectedCount + ' ' + $t('prm_impact_pending') }}
      </span>
    </div>

    <div class="cards">
      <div v-for="card in impact.cards" :key="card.id" class="card" :class="'tone-' + card.id">
        <div class="card-icon"><b-icon pack="fas" :icon="iconFor(card.id)" size="is-small"></b-icon></div>
        <div class="card-main">
          <div class="card-label">{{ card.label }}</div>
          <div class="card-value" :class="{ neg: card.value < 0 }">{{ eur(card.value) }}</div>
          <div class="card-count">{{ $t('prm_co_count', [card.count]) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { fmtEur } from '../shared/format'

  export default {
    name: 'PrmImpactPanel',
    props: {
      impact: { type: Object, required: true },
    },
    methods: {
      eur: fmtEur,
      // Icono por tipo de caja (confirmadas / pendientes / total).
      iconFor (id) {
        return { confirmed: 'circle-check', expected: 'clock', both: 'layer-group' }[id] || 'circle-info'
      },
    },
  }
</script>

<style lang="scss" scoped>
  .impact { border: 1px solid #d4dae3; border-bottom: 0; background: #fff; padding: 12px 16px; }
  .impact-title { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; font-size: 12px; font-weight: 700; color: #1e3046; }
  .impact-sub { font-size: 10px; font-weight: 400; color: #9aa4b2; }

  .cards { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; }

  // Tile con acento a la izquierda + insignia de icono, para que cada caja se lea
  // como un dato con identidad y no como un recuadro vacío.
  .card {
    display: flex; align-items: center; gap: 12px;
    border: 1px solid #dbe1ea; border-left-width: 4px; border-radius: 10px;
    padding: 11px 14px; background: #fff;
  }
  .card-icon {
    display: flex; align-items: center; justify-content: center;
    width: 34px; height: 34px; border-radius: 9px; flex-shrink: 0;
  }
  .card-main { min-width: 0; }
  .card-label { font-size: 11px; font-weight: 700; color: #33475f; }
  .card-value { font-size: 21px; font-weight: 800; line-height: 1.15; color: #1e3046; font-variant-numeric: tabular-nums; }
  .card-value.neg { color: #c0392b; }
  .card-count { font-size: 10px; font-weight: 600; color: #9aa4b2; }

  // Tonos por significado: confirmadas (verde), pendientes (ámbar), total (azul).
  .tone-confirmed { border-left-color: #2e7d5b; background: #f6fbf8; }
  .tone-confirmed .card-icon { background: #e0f0e7; color: #2e7d5b; }
  .tone-confirmed .card-value:not(.neg) { color: #1e7a3d; }

  .tone-expected { border-left-color: #e0a020; background: #fffbf2; }
  .tone-expected .card-icon { background: #fbeecf; color: #b9791a; }
  .tone-expected .card-value:not(.neg) { color: #b9791a; }

  .tone-both { border-left-color: #3d6b9a; background: #f5f8fc; }
  .tone-both .card-icon { background: #e3edf7; color: #33475f; }
</style>
